import { Text, useDripsyTheme } from "dripsy";
import * as React from "react";

function HelperText({ type, visible, children }: { type: "error" | "info"; visible: boolean; children: any }) {
  const { theme } = useDripsyTheme();
  const color = (): string => {
    switch (type) {
      case "error":
        return theme.colors.$error;
      case "info":
        return theme.colors.$textSecondary;
    }
  };

  if (!visible) {
    return null;
  }
  return (
    <Text
      sx={{
        marginBottom: 15,
        marginLeft: 8,
        marginRight: 8,
        color: color(),
        fontWeight: "500",
      }}
    >
      {children}
    </Text>
  );
}

export default HelperText;
